import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, OccEndpointsService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from 'src/app/spartacus/features/asm/asm-constant';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageExtendService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);

  constructor(
    private meta: Meta,
    protected baseService: BaseSiteService,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    protected http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private storageService: StorageService
  ) {}

  setShimanoActiveLanguage(language: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const params = new HttpParams().set('language', language);

    return this.auth.getUserId().pipe(
      switchMap((userCurrent) => {
        return this.http
          .patch(this.occEndpointsService.buildUrl(`/users/${userCurrent}`), { language }, { headers, params })
          .pipe(catchError((error: any) => throwError(error)));
      })
    );
  }

  getShimanoActiveLanguage(): Observable<any> {
    return this.auth.getUserId().pipe(
      take(1),
      switchMap((userCurrent) => {
        return this.http
          .get(this.occEndpointsService.buildUrl(`/users/${userCurrent}`), { headers: this.headers })
          .pipe(
            catchError((error: any) => throwError(error)),
            map((info) => (info ? info : {})),
            shareReplay()
          );
      })
    );
  }

  getAvailableLanguages(): Observable<any> {
    return this.auth.getUserId().pipe(
      take(1),
      switchMap((userCurrent) => {
        return this.http
          .get(this.occEndpointsService.buildUrl(`/users/${userCurrent}/available-languages`), {
            headers: this.headers,
          })
          .pipe(catchError((error: any) => throwError(error)));
      })
    );
  }
}
